import { Component, EventEmitter, Input, OnInit } from '@angular/core'
import { Charity, CharityService, MessageService } from "@bequeathed/ngx-services";
import { LoggerService } from "@bequeathed/ngx-app-core"

const LOG: LoggerService = LoggerService.get('CharityComponent')

/**
 * Component to handle interaction with the PayPal Giving app
 *
 * @author Dan Bennett (dbennett)
 */
@Component({
    selector: 'app-charity-display',
    templateUrl: './charity-display.component.html',
    styleUrls: ['./charity-display.component.sass']
})
export class CharityDisplayComponent implements OnInit {

    // @ts-expect-error this is fine
    @Input() interviewId: number
    // @ts-expect-error this is fine
    @Input() charity: Charity
    // @ts-expect-error this is fine
    @Input() confirmDonationTrigger: EventEmitter<Charity>

    constructor(
        private charityService: CharityService,
        private messageService: MessageService) {
    }

    get messages(): MessageService {
        return this.messageService
    }

    ngOnInit(): void {
        LOG.debug('init', `Loading charity: ${this.charity.initiator}`)
    }

    confirmDonation(): void {
        this.confirmDonationTrigger.next(this.charity)
    }
}
